import { Link } from 'react-router-dom';
import { PageHeader, Hero } from '../components/PageComponents';
import './Consultancy.css';

const features = [
  {
    icon: '⚙',
    title: 'Customized Solutions',
    description: 'We help our customers build customized software platforms. SMART-WARES has more than 10 years experience in designing reliable and extensible software solutions tailored to your exact business requirements.'
  },
  {
    icon: '☁',
    title: 'Cloud & On-Premise Deployment',
    description: 'Our software applications can be deployed either in our customers\' premises or on the Cloud platform. Our solutions are built on a responsive framework and work seamlessly on PC and mobile devices.'
  },
  {
    icon: '✓',
    title: 'Reliable Delivery',
    description: 'Our development methodology is based on a sound and secure framework. We put our best effort and resources to deliver applications based on agreed-upon milestones and timelines.'
  }
];

function Consultancy() {
  return (
    <>
      <Hero 
        imageSrc="/Images/PI-ID414963.jpg"
        imageAlt="Software Consultancy"
        title="Software Consultancy"
        subtitle="Expert software development services for your business"
      />

      <div className="container">
        {/* Features Grid - Equal Height Cards */}
        <section className="section">
          <div className="features-grid-equal">
            {features.map((feature, index) => (
              <div key={index} className="feature-card-equal">
                <div className="feature-card-inner">
                  <div className="consultancy-feature-icon">{feature.icon}</div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="section section-sm">
          <div className="consultancy-cta">
            <div className="consultancy-cta-content">
              <h3>Ready to build something great?</h3>
              <p>Tell us about your project and we'll provide a tailored proposal. From discovery to delivery, we partner with you every step of the way.</p>
            </div>
            <div className="consultancy-cta-action">
              <Link to="/contact" className="button button-outline-white button-large">Get in Touch →</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Consultancy;
